import { Toaster } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import ErrorPage from "./pages/ErrorPage";
import CotacaoPage from "./pages/CotacaoPage";
import LuckySpinPage from "./pages/LuckySpinPage";
import NeobuxEstrategiaPage from "./pages/NeobuxEstrategiaPage";
import NeobuxCadastroPage from "./pages/NeobuxCadastroPage";
import MelhoresSitesPage from "./pages/MelhoresSitesPage";
import MelhoresSitesCompletoPage from "./pages/MelhoresSitesCompletoPage";
import BitchutePage from "./pages/BitchutePage";
import RumblePage from "./pages/RumblePage";
import VideosPage from "./pages/VideosPage";
import VideosEngracadosPage from "./pages/VideosEngracadosPage";
import JogoBichoPage from "./pages/JogoBichoPage";
import EncurtaPage from "./pages/EncurtaPage";
import PalavraViva from "./pages/PalavraViva";
import TrilhosTrem from "./pages/TrilhosTrem";
import CorteCerto from "./pages/CorteCerto";
import CanalOracao from "./pages/CanalOracao";
import MeusCanais from "./pages/MeusCanais";
import SeriesJaponesas from "./pages/SeriesJaponesas";
import LivesPage from "./pages/LivesPage";
import HotmartPage from "./pages/HotmartPage";
import MegazoneDownloadsPage from "./pages/MegazoneDownloadsPage";
import MusicfulPage from "./pages/MusicfulPage";
import NotaFiscalPaulistaPage from "./pages/NotaFiscalPaulistaPage";
import RadioOnlinePage from "./pages/RadioOnlinePage";
import SitesUsadosPage from "./pages/SitesUsadosPage";
import SonicSprountPage from "./pages/SonicSprountPage";
import VideosUsadosPage from "./pages/VideosUsadosPage";
import JogosPage from "./pages/JogosPage";
import CraftyCreationsPage from "./pages/CraftyCreationsPage";
import PlanetaTerraChamandoPage from "./pages/PlanetaTerraChamandoPage";
import LipSyncPage from "./pages/LipSyncPage";
import TranslatePage from "./pages/TranslatePage";
import DesignToolsPage from "./pages/DesignToolsPage";
const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/cotacao" element={<CotacaoPage />} />
          <Route path="/luckyspin" element={<LuckySpinPage />} />
          <Route path="/neobux-estrategia" element={<NeobuxEstrategiaPage />} />
          <Route path="/neobux-cadastro" element={<NeobuxCadastroPage />} />
          <Route path="/melhores-sites" element={<MelhoresSitesPage />} />
          <Route path="/melhores-sites-completo" element={<MelhoresSitesCompletoPage />} />
          <Route path="/lives" element={<LivesPage />} />
          <Route path="/bitchute" element={<BitchutePage />} />
          <Route path="/rumble" element={<RumblePage />} />
          <Route path="/videos" element={<VideosPage />} />
          <Route path="/videos-engracados" element={<VideosEngracadosPage />} />
          <Route path="/jogo-bicho" element={<JogoBichoPage />} />
          <Route path="/encurtador" element={<EncurtaPage />} />
          <Route path="/palavra-viva" element={<PalavraViva />} />
          <Route path="/trilhos-trem" element={<TrilhosTrem />} />
          <Route path="/corte-certo" element={<CorteCerto />} />
          <Route path="/canal-oracao" element={<CanalOracao />} />
          <Route path="/meus-canais" element={<MeusCanais />} />
          <Route path="/series-japonesas" element={<SeriesJaponesas />} />
          <Route path="/lives" element={<LivesPage />} />
          <Route path="/hotmart" element={<HotmartPage />} />
          <Route path="/megazone-downloads" element={<MegazoneDownloadsPage />} />
          <Route path="/musicful" element={<MusicfulPage />} />
          <Route path="/nota-fiscal-paulista" element={<NotaFiscalPaulistaPage />} />
          <Route path="/radio-online" element={<RadioOnlinePage />} />
          <Route path="/sites-usados" element={<SitesUsadosPage />} />
          <Route path="/sonic-sprount" element={<SonicSprountPage />} />
          <Route path="/videos-usados" element={<VideosUsadosPage />} />
          <Route path="/jogos" element={<JogosPage />} />
          <Route path="/crafty-creations" element={<CraftyCreationsPage />} />
          <Route path="/planeta-terra-chamando" element={<PlanetaTerraChamandoPage />} />
          <Route path="/lipsync-tutorial" element={<LipSyncPage />} />
          <Route path="/translate" element={<TranslatePage />} />
          <Route path="/design-tools" element={<DesignToolsPage />} />
          <Route path="*" element={<ErrorPage />} />
        </Routes>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
